import { LOADING } from "../../../constants/constant";
import {
  REINVITE_USER_FAILED_ADMIN_PORTAL,
  REINVITE_USER_REQUESTED_ADMIN_PORTAL,
  REINVITE_USER_RESET_ADMIN_PORTAL,
  REINVITE_USER_SUCCESS_ADMIN_PORTAL,
} from "../../actions/ActionType";

const initialState = {
  status: "INIT",
  isLoading: undefined,
};

export default function getReInviteUserAdminPortalReducer(state = initialState, action) {
  switch (action.type) {
    case REINVITE_USER_REQUESTED_ADMIN_PORTAL:
      let reqstState = Object.assign({}, state);
      reqstState.reInviteUserIsLoading = true;
      reqstState.status = LOADING;
      return reqstState;

    case REINVITE_USER_SUCCESS_ADMIN_PORTAL:
      let userRes = Object.assign({}, state);
      console.log(
        "REInvite user reducer => Case => Success:admin portal :" +
          JSON.stringify(action.data)
      );
      userRes.reInviteUserStatus = action.data.status_message;
      userRes.reInviteUserStatusCode = action.data.status_code;
      userRes.reInviteUserIsLoading = false;
      // userRes.reInviteUserMessage = action.data.message;
      userRes.reInviteUserData = action.data.data;

      return userRes;

    case REINVITE_USER_FAILED_ADMIN_PORTAL:
      console.error(
        "Invite User Reducer => Case => Error:Admin portal " +
          JSON.stringify(action.error)
      );
      return Object.assign({}, state, action.error);

    case REINVITE_USER_RESET_ADMIN_PORTAL: {
      return initialState;
    }

    default:
      return state;
  }
}
